import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { Container, Icon } from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import { IdNamePair } from 'types/types';
import { TopFilterProps } from 'types/TopFilterProps';

import { getDefaultFilters, readFilterTagsFromQuery, staticFilters } from '../../utils/helpers';
import './TopFilter.less';

const getFilterId = (idFilters: IdNamePair[], filter: string) =>
  idFilters.find((x: IdNamePair) => x.name === filter)?.id ?? '';

const renderFilters = (
  idFilters: IdNamePair[],
  filterNames: string[],
  selectedFilters: string[],
  onToggleFiltersBigMenu: (showMenu: boolean) => void,
  showFiltersBigMenu: boolean
) =>
  filterNames.map((item, levelIndex) => (
    <div className="filter" id="top-filters" key={`top-filter-${uuidv4()}`}>
      <label>{item} &nbsp;</label>
      <br />
      <span
        className="top-filter"
        onClick={() => onToggleFiltersBigMenu(!showFiltersBigMenu)}
        id={getFilterId(idFilters, selectedFilters[levelIndex])}
      >
        {selectedFilters[levelIndex] ?? ''}
      </span>
    </div>
  ));

const renderFilterIcon = (
  onToggleFiltersBigMenu: (showMenu: boolean) => void,
  showFiltersBigMenu: boolean
) => (
  <div className="filter top-filter" id="top-filter-icon">
    <span className="filter-icon">
      <Icon
        className="pos filter"
        size="large"
        onClick={() => onToggleFiltersBigMenu(!showFiltersBigMenu)}
      />
    </span>
  </div>
);

export const TopFilter = ({
  filterNames,
  filters,
  showFiltersBigMenu,
  onToggleFiltersBigMenu,
}: TopFilterProps) => {
  const location = useLocation();

  const [selectedFilters, setSelectedFilters] = useState<string[]>(
    readFilterTagsFromQuery(location.search)
  );
  const [idFilters, setIdFilters] = useState<IdNamePair[]>(
    getDefaultFilters(filters, staticFilters, selectedFilters, 0).data
  );

  useEffect(() => {
    const filterTagsFromQuery = readFilterTagsFromQuery(location.search);
    setIdFilters(getDefaultFilters(filters, staticFilters, filterTagsFromQuery, 0).data);
    setSelectedFilters(filterTagsFromQuery);
  }, [filters, location.search]);

  return (
    <Container className="selected-filters">
      {renderFilters(
        idFilters,
        filterNames,
        selectedFilters,
        onToggleFiltersBigMenu,
        showFiltersBigMenu
      )}
      {renderFilterIcon(onToggleFiltersBigMenu, showFiltersBigMenu)}
    </Container>
  );
};
